<template>
  <v-menu left min-width='10rem' offset-y>
    <span slot="activator">
      <v-btn icon small style="margin-right: 0;"><v-icon :class="textClass">print</v-icon></v-btn>      
      <span :class="textClass">{{'Печать'}}</span>
    </span>
    <v-list dense>
      <template v-for="action in this.actions">
      <v-divider v-if="action.divider"></v-divider>
      <v-list-tile v-else :key="action.caption()" v-show="action.isVisible()" @click="action.run()">
        <v-list-tile-title>{{ action.caption() }}</v-list-tile-title>
      </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'print-btn',
    props: {
      actions: {
        type: Array,
        default () {
          return []
        }
      },
      primary: {
        type: Boolean,
        default: true
      }
    },
    data: function () {
      return {
      }
    },
    created () {
    },
    computed: {
      textClass () {
        return this.primary ? 'primary--text' : ''
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// PrintBtn.vue?156928ec